<!-- Header  -->
<div class="subheader with-padding flgrow">
  <div class="row align-items-center">
    <div class="col-6 col-lg-3">
      <div class="d-flex">
        <!-- Search  -->
        <div class="input-group">
          <input class="form-control" type="text" name="searchTerm" placeholder="{{ 'lblSearchByName' | translate }}"
            [(ngModel)]="campaignRequestModel.searchTerm" autocomplete="off" (keyup.enter)="onSearch()" />
          <div class="input-group-append">
            <button type="button" class="btn btn-primary" (click)="onSearch()">
              <em class="fa fa-search"></em>
            </button>
          </div>
        </div>
        <!-- Advance Search -->
        <div class="ml-2 advanced-search-box">
          <button type="button" (click)="onAdvanceSearch()" aria-label="Center Align" class="btn btn-primary">
            <em aria-hidden="true" class="fa fa-search-plus"></em>
          </button>
          <div class="searchbox card fix lt width600px" *ngIf="isAdvanceSearch">
            <div class="row">
              <!-- Date Range Picker -->
              <div class="col-6">
                <label translate> lblDate </label>
                <div class="date">
                <input bsDaterangepicker [bsConfig]="myDateRangePickerOptions" class="form-control" 
                [(ngModel)]="selectedDate" required/>
                </div>
              </div>
              <!-- Campaign Type -->
              <div class="col-6">
                <label translate>lblCampaignType</label>
                <ng-select [multiple]="false" class="w-100" placeholder="{{ 'lblCampaignType' | translate }}"
                  [(ngModel)]="campaignRequestModel.campaignType">
                  <ng-option *ngFor="let campaign of campaignTypeList" [value]="campaign.key">
                    {{ campaign.campaignTypeCode | translate }}</ng-option>
                </ng-select>
              </div>
            </div>
            <div class="row mt-3">
              <!-- Campaign Via -->
              <div class="col-6">
                <label translate>lblCampaignVia</label>
                <ng-select [multiple]="false" class="w-100" placeholder="{{ 'lblCampaignVia' | translate }}"
                  [(ngModel)]="campaignRequestModel.campaignVia">
                  <ng-option *ngFor="let campaign of campaignViaList" [value]="campaign.key">
                    {{ campaign.campaignViaCode | translate }}</ng-option>
                </ng-select>
              </div>
              <!-- Status -->
              <div class="col-6">
                <label translate>lblStatus</label>
                <ng-select [multiple]="false" class="w-100" placeholder="{{ 'lblStatus' | translate }}"
                  [(ngModel)]="campaignRequestModel.campaignStatus">
                  <ng-option *ngFor="let campaign of campaignStatusList" [value]="campaign.key">
                    {{ campaign.campaignStatusCode | translate }}</ng-option>
                </ng-select>
              </div>
            </div>
            <hr />
            <!-- Action Button -->
            <div class="row">
              <div class="col text-right">
                <button aria-label="Center Align" (click)="onSearch()" class="btn btn-primary mr-sm-2" translate>
                  lblApply
                </button>
                <button aria-label="Center Align" (click)="onReset()" class="btn btn-outline-tertiary mr-sm-2"
                  translate>
                  lblReset
                </button>
                <button (click)="onClose()" aria-label="Center Align" class="btn btn-outline-tertiary mr-sm-2"
                  translate>
                  lblClose
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Select Campaign For -->
    <div class="col-6 col-lg-3">
      <ng-select [multiple]="false" class="w-100 disable-clear-all" [clearable]="false" [searchable]="false"
        (change)="onChange($event)" [(ngModel)]="campaignRequestModel.campaignFor">
        <ng-option *ngFor="let item of campaignForList" [value]="item.id" translate>
          {{ item.name }}
        </ng-option>
      </ng-select>
    </div>
    <!-- Create Campaign -->
    <div class="col-auto ml-auto">
      <button type="button" (click)="onReset()" class="btn btn-primary btn-md"
        ngbTooltip="{{ 'lblClearFilters' | translate }}" placement="bottom" aria-label="Center Align">
        <em class="far fa-times-circle font16 align-top"></em>
      </button>
      <button type="button" type="reset" aria-label="Center Align" *ngIf="userRoleRightsDetails.canAdd"
        class="ml-3 add-button btn btn-primary" (click)="onEdit('create', 0)" translate>
        lblCreateCampaign
      </button>
    </div>
  </div>
</div>

<div class="container prel">
  <div class="row">
    <div class="c12">
      <div class="card">
        <!-- Title -->
        <div class="card-header d-flex justify-content-between">
          <h4 class="card-title">
            {{
            campaignForList[campaignRequestModel.campaignFor].name | translate
            }}
          </h4>
          <div class="font16 fontbold">
            <span class="font16 fontnormal" translate>lblTotal</span>:&nbsp;{{
            totalCount
            }}&nbsp;<span class="font16 fontnormal" translate>lblResults</span>
          </div>
        </div>
        <div id="scrollDiv" class="table-responsive max-h200" infinite-scroll [infiniteScrollDistance]="scrollDistance"
          [infiniteScrollThrottle]="throttle" [scrollWindow]="false" (scrolled)="onScrollDown($event)">
          <table class="tablest1">
            <thead>
              <tr>
                <th scope="col" style="width: 55px">#</th>
                <th scope="col" sortable="Name" (sort)="onSort($event)" translate>
                  lblName
                </th>
                <th scope="col" sortable="UpdatedBy" (sort)="onSort($event)" translate>
                  lblOwner
                </th>
                <th scope="col" sortable="StartDate" (sort)="onSort($event)" translate>
                  lblDate
                </th>
                <th class="text-center" scope="col" translate>lblSent</th>
                <th class="text-center" scope="col" translate>lblOpened</th>
                <th class="text-center" scope="col" translate>lblClicked</th>
                <th class="text-center" scope="col" translate>lblBounced</th>
                <th class="text-center" scope="col" translate>
                  lblUnsubscribed
                </th>
                <th scope="col" sortable="Status" (sort)="onSort($event)" translate>
                  lblStatus
                </th>
                <th class="text-center" scope="col" translate>lblIsActive</th>
                <th class="text-center" scope="col" translate>lblAction</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngIf="campaignList?.length > 0; else load_else">
                <tr *ngFor="let item of campaignList; let i = index">
                  <td>{{ i + 1 }}</td>
                  <td>{{ item.name }}</td>
                  <td>{{ item.updatedBy }}</td>
                  <td>{{ item.startDate | date : "short" }}</td>
                  <ng-container *ngIf="item.statistics === null; else else_stat">
                    <td class="text-center" colspan="5" translate>
                      lblCampaignStepisnotcreated
                    </td>
                  </ng-container>
                  <ng-template #else_stat>
                    <td class="text-center">
                      {{ item.statistics.Sent }}
                    </td>
                    <td class="text-center">
                      {{ item.statistics.Opened }}
                    </td>
                    <td class="text-center">
                      {{ item.statistics.Clicked }}
                    </td>
                    <td class="text-center">
                      {{ item.statistics.Bounced }}
                    </td>
                    <td class="text-center">
                      {{ item.statistics.Unsubscribed }}
                    </td>
                  </ng-template>
                  <td>
                    {{
                    campaignStatusList[item.status - 1]?.campaignStatusCode
                    | translate
                    }}
                  </td>
                  <td class="text-center">
                    <em class="fas fa-check" *ngIf="item.isActive"></em>
                    <em class="fas fa-times cursordisable" *ngIf="!item.isActive"></em>
                  </td>
                  <td class="text-center nowrap">
                    <a class="btn btn-ico" ngbTooltip="{{ 'lblView' | translate }}"
                      *ngIf="userRoleRightsDetails.canView" (click)="onEdit('view', item.id)">
                      <em class="fas fa-eye fa-lg"></em>
                    </a>
                    <span class="ico-div" *ngIf="userRoleRightsDetails.canEdit"></span>
                    <a class="btn btn-ico" ngbTooltip="{{ 'lblEdit' | translate }}" [class.disabled]="item.status != 1"
                      *ngIf="userRoleRightsDetails.canEdit" (click)="onEdit('edit', item.id)">
                      <em class="fas fa-pencil-alt fa-lg"></em>
                    </a>
                    <span class="ico-div" *ngIf="userRoleRightsDetails.canDelete"></span>
                    <a class="btn btn-ico" ngbTooltip="{{ 'lblDelete' | translate }}"
                      [class.disabled]="item.status != 1" *ngIf="userRoleRightsDetails.canDelete"
                      (click)="onDelete(item.id)" tooltipClass="custom-revert">
                      <em class="far fa-trash-alt fa-lg"></em>
                    </a>
                  </td>
                </tr>
              </ng-container>
              <ng-template #load_else>
                <tr>
                  <td colspan="12" class="no-record" translate>
                    lblNoRecordsFound
                  </td>
                </tr>
              </ng-template>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>